import React, { useState, useEffect } from "react";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import IntroAnimation from "./components/IntroAnimation";
import Routes from "./Routes";

function App() {
  // Check if intro was already seen in this session
  const [introComplete, setIntroComplete] = useState(() => {
    return sessionStorage.getItem('lumiveta_intro_seen') === 'true';
  });

  const handleIntroComplete = () => {
    sessionStorage.setItem('lumiveta_intro_seen', 'true');
    setIntroComplete(true);
  };

  return (
    <LanguageProvider>
      <AuthProvider>
        {!introComplete && (
          <IntroAnimation onComplete={handleIntroComplete} />
        )}
        <div className={introComplete ? 'opacity-100' : 'opacity-0'} style={{ transition: 'opacity 0.5s ease-in' }}>
          <Routes />
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
